import { PreparePaymentSource } from '@acorn-portal/shared/src/services/api';

/** The Braintree drop-in payment-method type for a PayPal (wallet) payment. */
export const BRAINTREE_PAYPAL_TYPE = 'PayPalAccount';

/** Resolves the PreparePaymentSource from the Braintree payment method type: PayPal is WALLET, card and Apple/Google Pay are CARD. */
export const resolvePreparePaymentSource = (braintreePaymentType: string | undefined): PreparePaymentSource =>
	braintreePaymentType === BRAINTREE_PAYPAL_TYPE ? PreparePaymentSource.WALLET : PreparePaymentSource.CARD;
